// Renderer/estimator chrome shared by fixed-height stream and thread rows. These values belong
// here instead of either component or estimator so changing layout spacing cannot update only one
// side of the static geometry contract.
export const ANSWER_CONTENT_TOP_PADDING_PX = 15
// Reply-card PostAnswer geometry: a normal byline occupies one 24px text row. When there is no
// rendered content row beneath it, the header instead contains the avatar's 4px top offset plus
// its 40px circle. The renderer consumes the full height and the estimator consumes the delta so
// the two sides cannot drift independently.
export const REPLY_CARD_BYLINE_HEIGHT_PX = 24
export const REPLY_CARD_BODYLESS_HEADER_HEIGHT_PX = 44
export const REPLY_CARD_BODYLESS_HEADER_EXTRA_HEIGHT_PX =
    REPLY_CARD_BODYLESS_HEADER_HEIGHT_PX - REPLY_CARD_BYLINE_HEIGHT_PX
export const QUEST_STREAM_CRUMB_CHROME_PX = 38
// Single-line reason label (15px line + 5px gap). Desktop renders it above the card frame,
// full-bleed mobile inside it — both placements are sized to this same total so the shell
// reserve is breakpoint-independent.
export const QUEST_STREAM_REASON_LABEL_CHROME_PX = 20
